import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from './Table';
import { Api } from '../api';
import { Space } from 'antd';
//import { CategoriesFilter } from './CategoriesFilter';
import BasicTableFilter from './BasicTableFilter';




const columns = [
    {
        title: "id",
        sorter: true,
        dataIndex: "_id",
        width: '20%',
        key: "_id",
        render: (text: string) => {
            return (<Link to={`/packages/update/${text}`}>{text}</Link>)
        }
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: "name",
        sorter: true,
        width: '20%',
    },
];

const PackageTable = () => {
    return (
        <Space style={{ width: '100%' }} direction="vertical">
            <Table
                tableId={ "packagesTable" }
              deleteApiCall={Api.packages.delete}
                allowDelete={true}
                restoreApiCall={Api.packages.restore}
                actions={(record: any) => (
                    <Link to={`/packages/update/${record._id}`}>View</Link>
                )}
                Filter={BasicTableFilter}
             apiCall={Api.packages.table} columns={columns} />
        </Space>
    )
};

export default PackageTable;